import React, { useContext, useEffect } from 'react';
import { LogoLoading } from 'ensightful-koala-ui';
import { styled } from '@mui/material';

import { useInstructor } from 'contexts/instructorRole';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/TaskManager/PageProvider';
import { Box, Container, Tabs } from 'shell/components';

const PageLayout = () => {
    const { getTaskTemplates, getMilestones } = useInstructor();
    const { isLoading } = useUser2();
    const { device } = useViewport();

    const { options, tab, setTab } = useContext(PageContext);

    useEffect(() => {
        (async () => {
            await getTaskTemplates();
            await getMilestones();
        })();
    }, []);

    return isLoading ? (
        <LogoLoading />
    ) : (
        <Container device={device}>
            <RootBox device={device}>
                <Tabs
                    aria-label={'select task templates or milestones'}
                    options={options}
                    selected={tab}
                    onChange={setTab}
                />
            </RootBox>
        </Container>
    );
};

const RootBox = styled(Box)(({ device, theme }) => {
    return {
        width: '100%',
        ...((device === 'tablet' || device === 'desktop') && {
            borderRadius: '12px 12px 0 0',
            width: '100%',
            minHeight: 'calc(100vh - 64px - 20px)',
            padding: theme.spacing(5, 5, 0),
            background: theme.palette.ensightful.shades[0],
        }),
    };
});

export default PageLayout;
